import AbstractElement from "./AbstractElement";
import Q1Element from "./Q1Element";
import Q2Element from "./Q2Element";
import {ViewEvent} from "../event/EventStaus";
import QuestionHelper from "../helper/QuestionHelper";
import Q3Element from "./Q3Element";
import Q4Element from "./Q4Element";
import QLoadingElement from "./QLoadingElement";
import QResultElement from "./QResultElement";
import QFormElement from "./QFormElement";
import QLineElement from "./QLineElement";
import QRecommendElement from "./QRecommendElement";


class QuestionElement extends AbstractElement {

    constructor(template: JQuery) {
        super(template);
    }

    init(): void {
        this.createElements();
    }

    private elementDate: any[];
    private currentElement: AbstractElement;
    private qaId: number;

    private createElements(): void {
        this.qaId = 0;
        this.elementDate = [
            {tagName: '.question-form', class: QFormElement},
            {tagName: '.question-line', class: QLineElement}
        ];
        this.elementDate.forEach((item) => {
            const ElementClass = item.class;
            const element = new ElementClass(this.template.find(item.tagName));
            item.target = element;
            element.emitter.on(ViewEvent.ON_TRANSITION_IN_COMPLETED, this.transitionHandler.bind(this));
            element.emitter.on(ViewEvent.ON_TRANSITION_OUT_COMPLETED, this.transitionHandler.bind(this));
            element.emitter.on('NEXT_QUESTION', () => {
                if (this.qaId < this.elementDate.length - 1) {
                    this.qaId += 1;
                    this.changeQuestion(this.qaId);
                }
            });
        });
        this.currentElement = this.elementDate[this.qaId].target;
        this.currentElement.template.addClass("active");
        this.currentElement.transitionIn();
    }

    public changeQuestion(id: number): void {
        if (this.currentElement) {
            this.currentElement.transitionOut({id: id});
            return;
        }
        this.currentElement = this.elementDate[id].target;
        this.currentElement.template.addClass("active");
        this.currentElement.transitionIn();
    }

    private transitionHandler(params: any = null): void {
        if (params.type === ViewEvent.ON_TRANSITION_IN_COMPLETED) {
            this.resize();
        }
        if (params.type === ViewEvent.ON_TRANSITION_OUT_COMPLETED) {

            this.currentElement.template.removeClass('active');
            this.currentElement = null;
            this.changeQuestion(params.id);
        }
    }
}

export default QuestionElement;